import LoginPage from "../components/pages/login-page"
import SummariesPage from "../components/pages/summaries-page"
import Summaries from "../screens/Summaries"
import ChangePassword from "../screens/change-password"
import CreateTransaction from "../screens/create-transaction"
import CreateUser from "../screens/create-user"
import Deals from "../screens/deals"
import AccountHistory from "../screens/history"
import Logout from "../screens/logout"
import OnlineConnections from "../screens/online-connections"
import Orders from "../screens/orders"
import Positions from "../screens/positions"
import { Navigate } from "react-router-dom"
import TradesByIP from "../screens/trades-by-ip"
import CommissionReport from "../screens/CommissionReport"
import ChangeUserGroup from "../screens/change-user-group"
import DailyReport from "../screens/DailyReport"
import DepositsAndWithdrawalsPage from "../screens/DepositsAndWithdrawals"
import OrdersHistory from "../screens/OrdersHistory";
import DealsHistory from "../screens/DealsHistory";
import CreditFacilityReport from "../screens/CreditFacilityReport";
import EditUser from "../screens/EditUser";
import EditUserPermission from "../screens/EditUserPermission";

// import OpenPositionsByDaysPage from "../components/pages/open-positions-by-days"
// import FrequentTrades from "../screens/frequent-trades"
// import Home from "../screens/home"
// import MostLosses from "../screens/most-losses"
// import MostProfitable from "../screens/most-profitable"
// import OpenPositions from "../screens/open-positions"
// import OpenPositionsByDays from "../screens/open-positions-by-days"
// import ScamTrades from "../screens/scam-trades"

export const routes = [
  {
    path: "/accounts",
    element: <Deals />,
  },
  {
    path: "/accounts/:login/edit",
    element: <EditUser />,
  },
  {
    path: "/accounts/:login/permission",
    element: <EditUserPermission />,
  },
  {
    path: "/accounts/:login",
    element: <AccountHistory />,
  },

  {
    path: "/positions",
    element: <Positions />,
  },

  {
    path: "/create-transaction",
    element: <CreateTransaction />,
  },

  {
    path: "/summaries",
    element: <Summaries />,
  },
  // orders

  {
    path: "/orders",
    element: <Orders />,
  },

  {
    path: "/create-user",
    element: <CreateUser />,
  },
  {
    path: "/change-password",
    element: <ChangePassword />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/logout",
    element: <Logout />,
  },
  {
    path: "/",
    element: <Navigate to="/accounts" />,
  }, //
  {
    path: "/connections",
    element: <OnlineConnections />,
  },
  {
    path: "/trades-by-ip",
    element: <TradesByIP />,
  },
  {
    path: "/commission-report",
    element: <CommissionReport />,
  },
  {
    path: "/change-user-group",
    element: <ChangeUserGroup />,
  },
  {
    path: "/daily-report",
    element: <DailyReport />,
  },
  {
    path: "/deposits-and-withdrawals",
    element: <DepositsAndWithdrawalsPage />,
  },
  {
    path: "/credit-facility",
    element: <CreditFacilityReport />,
  },
  {
    path: "/orders-history",
    element: <OrdersHistory />,
  },
  {
    path: "/deals-history",
    element: <DealsHistory />,
  },
  {
    path: "*",
    element: <>404 Page not found</>,
  },
];
